// useWasherPlanForm.js
import { ref, reactive } from '@vue/composition-api'

export function useWasherPlanForm(initialRows = []) {

  const form = reactive({
    id:  0,
    name:  '',
    device_id: '',
    camp_id: '',
    landfills: [],
    camp_leave: '',
    camp_back: '',
    count: 0
  })

  const rows = ref(
    initialRows.length
      ? initialRows.map((r) => ({ ...r }))
      : [
        {
          id: (Math.random() + 1).toString(36).substring(2),
          paths: [],
          week_ordinaries: [],
          week_days: [],
          containers_file: null,
          count: ''
        }
      ]
  )


  const initiate_form = initialForm => {
    for (let k in initialForm)
    {
      if (k in form) {
        form[k] = initialForm[k]
      }

      if (k === 'data')
      {
        form['landfills'] = initialForm[k].landfills
        rows.value = initialForm[k].schedules.map((r) => ({
          id: (Math.random() + 1).toString(36).substring(2),
          paths: r.work_areas,
          week_days: r.week_schedule,
          week_ordinaries: r.week_ordinaries,
          count: r.containers.length
        }))
      }
    }
  }


  const addRow = () => {
    rows.value.push({
      id: Date.now(),
      paths: [],
      week_ordinaries: [],
      week_days: [],
      containers_file: null,
      count: ''
    })
  }

  const removeRow = (index) => {
    rows.value.splice(index, 1)
  }

  const updateFile = (index, file) => {
    rows.value[index].file = file
  }

  const buildFormData = () => {

    const formData = new FormData()
    formData.append('type', 'washer')
    formData.append('id', form.id)
    formData.append('name', form.name)
    formData.append('device_id', form.device_id)
    formData.append('camp_id', form.camp_id)
    formData.append('camp_leave', form.camp_leave)
    formData.append('camp_back', form.camp_back)

    form.landfills.forEach(item => {
      formData.append('landfills[]', item);
    });


    rows.value.forEach((row, i) => {
      if (row.containers_file) {
        formData.append(`data[${i}][containers_file]`, row.containers_file)
      } else {
        formData.append(`data[${i}][containers_file]`, null)
      }

      row.week_ordinaries.forEach(item => formData.append(`data[${i}][week_ordinaries][]`, item));
      row.week_days.forEach(item => formData.append(`data[${i}][week_days][]`, item));
      row.paths.forEach(item => formData.append(`data[${i}][paths][]`, item));
    })


    return formData
  }


  const clearFormData = () => {

    for (let k in form) {
      if (k === 'id') {
        form[k] = 0
        continue
      }

      form[k] = ''
    }

    rows.value = [
      {
        id: Date.now(),
        paths: [],
        week_ordinaries: [],
        week_days: [],
        containers_file: null
      }
    ]

  }

  return {
    form,
    rows,
    addRow,
    removeRow,
    updateFile,
    buildFormData, clearFormData, initiate_form
  }
}
